import SelectComponent from 'react-select'
import { colors } from 'shared/styles/colors'
import { IDropdown } from './DropdownComponent.types'
import { ErrorMessage } from './styles'

export function Dropdown({
  options,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  errorMessage,
}: IDropdown): JSX.Element {
  const style = {
    option: provided => ({
      ...provided,
      color: colors.gray7,
    }),
    singleValue: provided => ({
      ...provided,
      color: colors.gray7,
    }),
    control: base => ({
      ...base,
      color: colors.gray7,
      border: `$1px solid ${colors.grayLight}`,
      boxShadow: `$1px solid ${colors.grayLight}`,
    }),
  }
  return (
    <>
      <SelectComponent
        placeholder={placeholder}
        onChange={newValue => onChange(newValue)}
        value={value}
        styles={style}
        options={options}
        isSearchable={false}
        required={required}
        onBlur={onBlur}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 4,
          colors: {
            ...theme.colors,
            primary: colors.gray4,
            primary25: colors.gray5,
          },
        })}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  )
}
